import { Component, OnInit } from '@angular/core';
import { NavigService } from 'src/app/services/navig.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit{

  constructor(
    public nav : NavigService
  ){}
  ngOnInit(){
  }

goFb(){
  window.open("https://www.facebook.com/profile.php?id=100091342660069", "_blank");
}
goLn(){
  window.open("https://www.linkedin.com/company/mace-assurance/", "_blank");
}
goInsta(){ 
  window.open("https://www.instagram.com/mace.assurance/", "_blank");
}

}
